module.exports = __webpack_public_path__ + "img/modules/assets/img/empty.072d9806f22b6a3d97233ea627850e3d.png";